import React, { Component } from "react";
import {Container, Row, Col,Image,Button,Form,Card,InputGroup } from 'react-bootstrap';
import "../CadreRegistration/cadreRegistration.css";
import { withRouter,Link } from "react-router-dom";
import loader from '../../images/loader.gif';
import "../EventsAndActivities/EventsAndActivities.css";
import { getAPICallDataForOnlyBSA } from '../../services/MemberService';

class MahanaduAttendence extends Component {
  constructor(props) {
    super(props);
    this.state = {
     searchTypeValue:"",
     validateSearchValue:"",
     otpLoadingSymbol:"hide",

    captureMobileNo:"",
    validateCaptureMobileNo:"",
    captureOTPNO:"",
    validateCaptureOTP:"",

    mobileNoDisabled:false,
    otpBlockShow:false,

    smsSentMessage:"",
    otpVerifiedMessageStatus:"",
    otpVerifiedLoadingSymbol:"hide",
    OTPSentStatus:"",
    resendOTPLoadingSymbol:"hide",
    resendSmsSentMessage:"",

    
    
    minutes:1,
    seconds:0,
    OTPVerifiedDisabledButton:true,
    getCurrentLocationCoordinatesForDV:{},
    finalSavingAttencdence:"hide",
    finalSuccessMessage:"",
    reloadTheBot:""
    
    };
    
    
  }

  componentDidMount() {
    
}


handleOnchangeInputBox = (e) => {
    const name = e.target.name;
    const value = e.target.value;

     if(name == "captureOTPNO"){
            this.setState({otpVerifiedMessageStatus:"",otpVerifiedLoadingSymbol:"show"});
            if(value.length >= 6){
                this.validateMobileOtp(value);
               
            }
            
        }


    this.setState({ [name]: value });
  }

sendOTPForMahanaduAttendance = () => {
    this.setState({
        validateCaptureMobileNo:"",
        captureOTPNO:"",
        validateCaptureOTP:"",

        mobileNoDisabled:false,
        otpBlockShow:false,

        smsSentMessage:"",
        otpVerifiedMessageStatus:"",
        otpVerifiedLoadingSymbol:"hide",
        OTPSentStatus:"",
        resendOTPLoadingSymbol:"hide",
        resendSmsSentMessage:"",

        
        
        minutes:1,
        seconds:0,
        OTPVerifiedDisabledButton:true
    });

    

    if(this.state.searchTypeValue == ""){
        this.setState({validateSearchValue:"Please Enter Membership"});
        return;
    }
    if(this.state.searchTypeValue.length < 8){
        this.setState({
            validateSearchValue: "Please Enter 8 Digits Valid Membership Id"
        });
        return;
    }

    this.setState({otpLoadingSymbol:"show"})
    this.setState({smsSentMessage:"",OTPSentStatus:"",otpVerifiedValue:0});

     navigator.geolocation.getCurrentPosition(this.showLocationDVMappingPostions,this.ShowLocationPermissionError)

    let userAccessObj;
     userAccessObj =  
        JSON.stringify({ 
            "membershipId" : this.state.searchTypeValue
        });

         getAPICallDataForOnlyBSA(userAccessObj,"sendOTPForMahanaduAttendance")
            .then((res) => res.json())
            .then((content) => {
                this.setState({otpLoadingSymbol:"hide"})
                if (content != null && content.status == "Success") {
                    this.setState({smsSentMessage:content.message,OTPSentStatus:content.status,otpVerifiedValue:1});
                    this.setState({OTPVerifiedDisabledButton:false})
                     this.OTPTimerFunction();
                }else if(content.status == "Fail"){
                    this.setState({smsSentMessage:content.message,OTPSentStatus:"Fail",otpVerifiedValue:0});
                    this.setState({OTPVerifiedDisabledButton:true})

                }else{
                    this.setState({smsSentMessage:"Some Thing Went Wrong,Please Try Again...",OTPSentStatus:"Fail",otpVerifiedValue:0});
                    this.setState({OTPVerifiedDisabledButton:true})
                }
            });
}

resendOTPTimer = () => {
    this.setState({minutes:1});
    this.setState({seconds:0});

    this.OTPTimerFunction();
};

OTPTimerFunction = () => {
    const interval = setInterval(() => {
        if (this.state.seconds > 0) {
        this.setState({seconds:this.state.seconds - 1});
        }

        if (this.state.seconds === 0) {
        if (this.state.minutes === 0) {
            clearInterval(interval);
        } else {
            this.setState({seconds:90});
            this.setState({minutes:this.state.minutes - 1});

        }
        }
    }, 1000);

    return () => {
        clearInterval(interval);
    };
}

resendOTPNew = () => {
    this.setState({validateSearchValue:"",OTPVerifiedDisabledButton:false });
   if(this.state.searchTypeValue == ""){
        this.setState({validateSearchValue:"Please Enter Membership"});
        return;
    }
    if(this.state.searchTypeValue.length < 8){
        this.setState({
            validateSearchValue: "Please Enter 8 Digits Valid Membership Id"
        });
        return;
    }
   

    this.setState({resendOTPLoadingSymbol:"show",otpVerifiedValue:0});

    const obj =  
        JSON.stringify({ 
           "membershipId" : this.state.searchTypeValue
        
        }); 

        getAPICallDataForOnlyBSA(obj,"sendOTPForMahanaduAttendance")
        .then((res) => res.json())
        .then((data) => {
        this.setState({resendOTPLoadingSymbol:"hide"});
        if(data !=null && data.status == "Success"){
            //console.log(jwt_decode(data.reference).sub)
            this.setState({otpVerifiedValue:1});
            this.resendOTPTimer();
        }else{
            this.setState({otpVerifiedValue:0});
        }
        });
    
}

    validateMobileOtp = (otp) => {
    this.setState({otpVerifiedMessageStatus:"",otpVerifiedLoadingSymbol:"show",validateCaptureOTP:""});
    const obj =  
        JSON.stringify({ 
        "membershipId" : this.state.searchTypeValue,
        "otp" : otp,
        

        }); 

        getAPICallDataForOnlyBSA(obj,"validateOTPForMahanaduFeedback")
        .then((res) => res.json())
        .then((data) => {
        this.setState({otpVerifiedLoadingSymbol:"hide"});
        if(data !=null && data.status == "Success"){
            this.setState({otpVerifiedMessageStatus:"Verified",OTPVerifiedDisabledButton:true,mobileNoDisabled:true,validateCaptureOTP:""});
            this.saveEventAttendanceByTgBot();
        }else{
            this.setState({otpVerifiedMessageStatus:"NotVerified",OTPVerifiedDisabledButton:false});
        }
        });
    }

    ShowLocationPermissionError = (error) => {
        console.log(error)
        switch (error.code){
            case error.PERMISSION_DENIED:
            alert("User Location Permission is Denied,Please Enable Location Services...(Path:Settings > Privacy > Location Services)");
            break;

            case error.POSITION_UNAVAILABLE:
            alert("User Postion Unavailable Denied");
            break;

            default:
                alert("An unknown error occurred")
        }
    }

    showLocationDVMappingPostions = (position) => {
        const getCoordinates =  
            { 
            "latitude" : position.coords.latitude,
            "longitude" : position.coords.longitude,
            "accuracy":position.coords.accuracy
            }
            
        this.setState({getCurrentLocationCoordinatesForDV:getCoordinates});

    }

     saveEventAttendanceByTgBot = () => {

        this.setState({finalSavingAttencdence:"show"})

        const obj =  
            JSON.stringify({ 
                "membershipId":this.state.searchTypeValue,
                "latitude": this.state.getCurrentLocationCoordinatesForDV.latitude,
                "longitude": this.state.getCurrentLocationCoordinatesForDV.longitude,
                

            }); 

            getAPICallDataForOnlyBSA(obj,"Event/saveEventAttendanceByTgBot")
            .then((res) => res.json())
            .then((result) => {
                this.setState({finalSavingAttencdence:"hide"});
                if(result !=null){
                      if(result.status == "Success"){//ara
                        this.setState({finalSuccessMessage:"Attendence Submitted Successfully..."});
                        setTimeout(() => { 
                            this.setState({
                                searchTypeValue:"",
                                validateSearchValue:"",
                                otpLoadingSymbol:"hide",

                                captureMobileNo:"",
                                validateCaptureMobileNo:"",
                                captureOTPNO:"",
                                validateCaptureOTP:"",

                                mobileNoDisabled:false,
                                otpBlockShow:false,

                                smsSentMessage:"",
                                otpVerifiedMessageStatus:"",
                                otpVerifiedLoadingSymbol:"hide",
                                OTPSentStatus:"",
                                resendOTPLoadingSymbol:"hide",
                                resendSmsSentMessage:"",

                                
                                
                                minutes:1,
                                seconds:0,
                                OTPVerifiedDisabledButton:true,
                                finalSuccessMessage:""
                            });
                        }, 2000);
                        

                      }else if(result.status == "Fail"){
                        this.setState({reloadTheBot:"reload"})
                        this.setState({finalSuccessMessage:"క్షమించాలి,మీరు మహానాడు వేదికకు 10 KM  పరిధిలోనించి మాత్రమే హాజరు (అటెండన్స్) ఇవ్వగలరు."})
                        
                      }else{
                         this.setState({reloadTheBot:"reload"})
                        this.setState({finalSuccessMessage:"క్షమించాలి,మీరు మహానాడు వేదికకు 10 KM  పరిధిలోనించి మాత్రమే హాజరు (అటెండన్స్) ఇవ్వగలరు"})
                        
                      }
                  }else{
                     this.setState({reloadTheBot:"reload"})
                    this.setState({finalSuccessMessage:"క్షమించాలి,మీరు మహానాడు వేదికకు 10 KM  పరిధిలోనించి మాత్రమే హాజరు (అటెండన్స్) ఇవ్వగలరు"})
                  }
            
            });
        }


        reloadtheEventAttendence = () => {
            this.setState({
                searchTypeValue:"",
                validateSearchValue:"",
                otpLoadingSymbol:"hide",

                captureMobileNo:"",
                validateCaptureMobileNo:"",
                captureOTPNO:"",
                validateCaptureOTP:"",

                mobileNoDisabled:false,
                otpBlockShow:false,

                smsSentMessage:"",
                otpVerifiedMessageStatus:"",
                otpVerifiedLoadingSymbol:"hide",
                OTPSentStatus:"",
                resendOTPLoadingSymbol:"hide",
                resendSmsSentMessage:"",

                
                
                minutes:1,
                seconds:0,
                OTPVerifiedDisabledButton:true,
                finalSuccessMessage:"",
                reloadTheBot:""
            });
        }


  render() {
    
    
    return (
      <section className="mb-4">
        <div className=''>
        <Image variant="top" src={require('../../images/TDP-Mahanadu-2025.jpg')} className='w-100' style={{height:"170px"}} />
        </div>
        <div className='p-1'>
            <Container>
                <Row>
                    <Col>
                        <div className="float-right mt-2">
                            <Link to={{pathname: "/dashboard"}}> 
                                <Button variant="outline-danger pad5_14" className='f-12  fw-bold'> <i class="fa-solid fa-house"></i> Home</Button> 
                            </Link>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='bor-bottom-yellow-pad mt-3'>
                            <h5 className='text-center color_red text-uppercase'>Mahanadu 2025 Attendance</h5>
                        </div>
                    </Col>
                </Row>

                <Row>
                <Col sm={12} className="mt-3">
                    <div className='border_pad mt-2'>
                        <Row>
                            <Col>
                             <label className="f-14 fw-bold">Membership No</label>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="mt-2">
                                <input type="text" name="searchTypeValue" placeholder="Enter Membership No" className="form-control from-control-sm"  maxLength="8" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                {
                                    this.state.validateSearchValue != "" ?
                                    (<span className="error_cls_new f-12">{this.state.validateSearchValue}</span>)
                                    :
                                    ("")
                                }
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Button type="button" className='btn btn-sm btn-success center-auto mt-3 fw-bold' onClick={(e) => this.sendOTPForMahanaduAttendance(e)}>GET OTP
                         {
                            this.state.otpLoadingSymbol == "show" ? 
                            (<Image src={loader} alt="loader" className='loader_cls ms-2'></Image>)
                            :
                            ("")
                        }
                    </Button>
                </Col>
            </Row>

            {
                this.state.OTPSentStatus == "Success" ?
                (
                    <>
                    <Row>
                        <Col>
                           <fieldset class=""><legend>Validate OTP</legend>  
                                <Row>
                                    <Col className='mt-2'>
                                        <Form>
                                            <Row>
                                                
                                                <Col className=''>
                                                <InputGroup className="">
                                                            <InputGroup.Text id="basic-addon1" className='f-12' style={{textAlign:"left",marginLeft:"0px"}}>OTP NO <span className='color_red f-14 ms-1'>*</span>  </InputGroup.Text>
                                                            <Form.Control type="text" name="captureOTPNO" maxLength={6} disabled={this.state.OTPVerifiedDisabledButton} className='form-control-sm' value={this.state.captureOTPNO}  placeholder="Enter OTP No" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                </InputGroup>
                                                <h6 className='color_red f-12 mt-2 font-weight-bold'>{this.state.validateCaptureOTP}</h6>
                                                </Col>
                                                
                                            </Row>
                                            
                                                <Row>
                                                    <Col>
                                                        {
                                                            this.state.OTPSentStatus == "Success"?
                                                            (
                                                                <>
                                                                    <h6 className='mt-2 f-12 color_green line_height_20'>{this.state.smsSentMessage} : <b >{this.state.captureMobileNo} </b></h6>
                                                                    
                                                                    {
                                                                        this.state.otpVerifiedMessageStatus != "Verified" || this.state.otpVerifiedMessageStatus == "" ?
                                                                        (
                                                                            <div className="countdown-text">
                                                                                {this.state.seconds > 0 || this.state.minutes > 0 ? (
                                                                                <h6 className='mt-2 f-14'>
                                                                                    Time Remaining : {this.state.minutes < 10 ? `0${this.state.minutes}` : this.state.minutes}:
                                                                                    {this.state.seconds < 10 ? `0${this.state.seconds}` : this.state.seconds}
                                                                                </h6>
                                                                                ) : (
                                                                                <h6 className='mt-2 f-12'>Didn't recieve code? </h6>
                                                                                )}
                                                                                {
                                                                                    this.state.resendOTPLoadingSymbol == "show" ?
                                                                                    (<Image src={loader} alt="loader" className='ms-2 get_otp_loading_symbol_cls'></Image>)
                                                                                    :
                                                                                    ("")
                                                                                } 
                                                                                <Button variant="dark" className='f-12 float-right mt-2' 
                                                                                disabled={this.state.seconds > 0 || this.state.minutes > 0}
                                                                                style={{
                                                                                    color: this.state.seconds > 0 || this.state.minutes > 0 ? "#DFE3E8" : "#fff",
                                                                                }} onClick={this.resendOTPNew}  >Resend OTP</Button>
                                                                                
                                                                            </div>
                                                                        )
                                                                        :
                                                                        ("")
                                                                    }
                                                                
                                                                    
                                                                </>
                                                            )
                                                            :
                                                            ("")
                                                        }
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col>
                                                        {
                                                                this.state.otpVerifiedLoadingSymbol == "show" ?
                                                                (<Image src={loader} alt="loader" className='loader_cls_otp ms-2'></Image>)
                                                                :
                                                                (
                                                                    this.state.otpVerifiedMessageStatus == "Verified" ?
                                                                    (

                                                                        <h6 class="color_green fw-bold f-14  text-center mt-2"><i class="fa-solid fa-check mr-2"> </i>OTP verified successfully </h6>
                                                                        
                                                                    )
                                                                    :
                                                                    (
                                                                        this.state.otpVerifiedMessageStatus == "NotVerified" ?
                                                                        (<h6 class="color_red fw-bold f-14 text-center mt-2"><i class="fa-solid fa-check mr-2"> </i>Not Verified,Please Enter Valid OTP </h6>)
                                                                        :
                                                                        ("")
                                                                        
                                                                    
                                                                    )
                                                            )
                                                        }
                                                    </Col>
                                                </Row>
                                            
                                        </Form>
                                    </Col>
                                </Row>
                            </fieldset>
                        </Col>
                    </Row>
                     {
                        this.state.otpVerifiedMessageStatus == "Verified" ? 
                        (
                            <>
                            {
                                this.state.finalSavingAttencdence == "show" ?
                                (
                                    <div class="row justify-content-center">
                                        <div class="col-sm-12 mt-2">
                                                <div class="loader-event">
                                                <Image src={loader} alt="loader" className='loader_cls_otp ms-2 git-icon'></Image>
                                                <span class="dot-loader">Loading</span>
                                            </div>
                                        </div>
                                        
                                    </div>
                                )
                                :
                                (
                                    <Row>
                                        <Col>
                                            <h5 className="mt-2 f-14" style={{lineHeight:"27px"}}>{this.state.finalSuccessMessage}</h5>
                                            {
                                                this.state.reloadTheBot == "reload" ?
                                                (
                                                    <h5 className="mt-2 f-14" onClick={()=>this.reloadtheEventAttendence()} style={{textDecoration:"underline",color:"red",cursor:"pointer"}}>Click here to Try Again <i class="fa-solid fa-arrow-right ms-1"></i> </h5>
                                                )
                                                :
                                                ("")
                                            }
                                        </Col>
                                    </Row>
                                )
                            }
                            </>
                            
                        )
                        :
                        ("")
                     }                                   
                    
                </>
                )
                :
                (
                    <Row>
                        <Col>
                            <h5 className="text-center color_red">{this.state.smsSentMessage}</h5>
                        </Col>
                    </Row>
                )
            }

            


            </Container>
        </div>
     </section>

    );
  }
}

export default withRouter(MahanaduAttendence);
